export enum ResultsDirection {
    TO_LEFT,
    TO_RIGHT,
}
